var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pointer-events-none fixed top-8 left-0 right-0 flex px-4 pb-6 z-50",class:_vm.containerClasses,attrs:{"aria-live":"assertive"}},[_c('div',{staticClass:"flex w-full flex-col items-start space-y-4",class:_vm.innerClasses},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }